import _ from 'lodash';
import BasketCard from '../../../../components/cards/BasketCard/index.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import navigateTo from '../../../../mixins/buy-flow';
import { ecommerceViewCartEvent, PRODUCT_TYPE } from '@/helpers';
import { globalLoader } from '@/helpers/variables';
import { debounce } from 'lodash';

export default {
  name: 'buy-flow',
  components: {
    BasketCard
  },
  mixins: [navigateTo],
  data() {
    return {
      PRODUCT_TYPE,
      kod: '',
      showBonusesInput: false,
      bonusesAmount: 0,
      disabledButton: false,
      width: window.innerWidth,
      syncPriceProductId: null
    };
  },

  async created() {
    globalLoader(true);
    this.resetRemovedSamples();
    await Promise.all([this._sync(), this._basketSync()]);
    globalLoader(false);

    let ecommerceData = this.basket.reduce(
      (acc, product) => {
        let { select_type, productPrices, title, brand, brandSeries, select_count } = product;

        let price = select_type?.price || productPrices.data[0].price;

        acc.items.push({
          item_id: select_type?.id || productPrices.data[0].id,
          item_name: title,
          item_brand: brandSeries?.title || 'Renew',
          item_category: brand?.title || '',
          item_variant: select_type?.title || productPrices.data[0].title,
          price,
          quantity: select_count
        });
        acc.value = acc.value + price * select_count;
        return acc;
      },
      { items: [], value: 0 }
    );

    let { items, value } = ecommerceData;

    ecommerceViewCartEvent({ value: value.toFixed(2), items });
  },
  watch: {
    bonusesAmount() {
      this.setBonuses({ pay_bonus_amount: this.bonusesAmount });
      this.$refs.bonusesError.innerHTML = '';
      this.disabledButton = false;

      if (this.bonusesAmount > this.user?.bonusAmount) {
        this.$refs.bonusesError.innerHTML = `доступно ${this.user.bonusAmount + ' бонусів'}`;
        this.disabledButton = true;
      }
    }
  },
  computed: {
    ...mapGetters({
      basket: 'basket/basket',
      isUserWithCode: 'profile/isUserWithCode',
      user: 'profile/user',
      isAuthenticated: 'auth/isAuthenticated',
      samples: 'samples/samples',
      gifts: 'gifts/gifts'
    }),
    checkBasketContainsPromotion() {
      return (
        this.basket.findIndex(
          (product) => product.select_type.hasActivePromotion || product.select_type.hasIndividualDiscount
        ) !== -1
      );
    },
    isShowTotalOldSum() {
      return this.basket.some((product) => product.select_type.oldPrice);
    },
    totalOldSum() {
      let bonusesAmount = this.bonusesAmount <= this.user?.bonusAmount ? this.bonusesAmount : 0;

      return (
        _.sumBy(this.basket, (product) => {
          let { select_type, select_count } = product;
          let price = select_type.oldPrice || select_type.price;
          return price * select_count;
        }) - bonusesAmount
      );
    },
    totalSum() {
      let bonusesAmount = this.bonusesAmount <= this.user?.bonusAmount ? this.bonusesAmount : 0;

      return _.sumBy(this.basket, (product) => product.select_type.price * product.select_count) - bonusesAmount;
    },
    discount() {
      if (!this.canSeeDiscount()) {
        return 0;
      }

      let sum = 0;

      this.basket.forEach((basketProduct) => {
        const clientPrice = basketProduct.client_price;

        // do not calculate for regular users
        if (!clientPrice) {
          return;
        }

        let discount = 0;

        const price = basketProduct.select_type;

        // for users with code calc actual discount, without promotion percent
        if (clientPrice.hasActivePromotion) {
          discount = clientPrice.oldPrice - price.oldPrice;
        } else {
          discount = clientPrice.price - price.price;
        }

        sum += discount * basketProduct.select_count;
      });

      return sum;
    }
  },
  methods: {
    ...mapActions({
      getSyncBasket: 'basket/GET_SYNC_BASKET',
      updateUserAssignCode: 'profile/UPDATE_USER_DATA',
      fetchUser: 'profile/FETCH_USER_DATA',
      checkSamples: 'samples/CHECK_SAMPLES',
      checkGifts: 'gifts/CHECK_GIFTS',
      checkSales: 'sales/CHECK_SALES'
    }),
    ...mapMutations({
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      setBonuses: 'basket/SET_USER_BONUSES',
      setRemovedSampler: 'samples/SET_REMOVED_SAMPLER',
      resetRemovedSamples: 'samples/RESET_REMOVED_SAMPLES'
    }),

    onCheckOrderCart: debounce(async function (productId) {
      try {
        this.syncPriceProductId = productId;
        await this._basketSync();
      } catch (e) {
        console.error(e);
      } finally {
        this.syncPriceProductId = null;
      }
    }, 500),

    async _basketSync() {
      let payloadSyncProductsBasket = this.basket.map(({ id, select_count }) => ({
        id,
        count: select_count
      }));

      await this.getSyncBasket(payloadSyncProductsBasket);

      let payloadSyncAddsBasket = this.basket.reduce((acc, { select_type, select_count }) => {
        acc[`products[${select_type.id}]`] = select_count;
        return acc;
      }, {});

      await Promise.all([
        this.checkGifts(payloadSyncAddsBasket),
        this.checkSamples(payloadSyncAddsBasket),
        this.checkSales(payloadSyncAddsBasket)
      ]);
    },

    async _sync() {
      if (!this.isAuthenticated) {
        return;
      }

      await this.fetchUser();
    },

    handleOrderClick() {
      this.navigateTo('buy-flow-order');
    },

    canSeeDiscount() {
      return this.user && this.isUserWithCode;
    },

    updateWidth() {
      this.width = window.innerWidth;
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  }
};
